import { useRef } from "react";

// Entrance fade-up. Content is never hidden: the animation is a pure enhancement
// that plays on mount, so async re-renders can never leave a section blank.
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  return (
    <Tag
      ref={ref}
      style={{ animationDelay: `${delay}ms` }}
      className={`reveal ${className}`}
    >
      {children}
    </Tag>
  );
}
